import { VALID_THEMES, THEME_DEFAULT, ValidTheme } from 'consts/theme';

export function getTheme(): ValidTheme {
  return VALID_THEMES.includes(window.theme)
    ? (window.theme as ValidTheme)
    : THEME_DEFAULT;
}
